module.exports = __webpack_public_path__ + "img/Rel.Colleagues.94610861.png";